import React from "react";
import { getFullName, getAddress } from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import {
  IonLabel,
  IonItem,
  IonAvatar,
  IonBadge,
  useIonModal,
} from "@ionic/react";
import VisitModal from "./VisitModal";
import { ReactComponent as AvatarImg } from "../../../assets/avatar.svg";
import moment from "moment";
import { Img } from "react-image";
var flatten = require("flat");

const VisitItem = (props) => {
  const { item, patientId, branchId } = props;
  const intl = useIntl();
  const daysFromLastVisit =
    item.last_visit_time &&
    moment(item.date).diff(moment(item.last_visit_time), "days");
  const color = item.overflow_months_number > 0 ? "danger" : "light";

  const [present, dismiss] = useIonModal(
    <VisitModal
      patientId={patientId}
      branchId={branchId}
      hideModal={() => dismiss()}
      houseVisitsId={item.id}
    />,
    {
      onHide: () => dismiss(),
    }
  );
  return (
    <IonItem
      key={item.id}
      detail={true}
      onClick={() => {
        present({});
      }}
    >
      <IonAvatar slot="start">
        {item.patient.avatar_url ? (
          <Img
            src={[item.patient.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        ) : (
          <AvatarImg style={{ borderRadius: "50%" }} />
        )}
      </IonAvatar>
      <IonLabel>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <IonLabel>
            {getFullName(item.patient.surename, item.patient.first_name)}
          </IonLabel>
          <IonLabel color="medium">
            {moment(item.date).format("DD/MM/YYYY")}
          </IonLabel>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <IonLabel color="medium">
            {getAddress(flatten(item.patient, { safe: true }))}
          </IonLabel>
          {item.approved && (
            <IonBadge color="success" slot="end">
              {intl.formatMessage({
                id: "app.mobile.table.verified",
              })}
            </IonBadge>
          )}
        </div>
        <IonBadge color={color} slot="end">
          {daysFromLastVisit
            ? `${daysFromLastVisit} ${intl.formatMessage({
                id: "app.mobile.months_from_last_visit",
              })}`
            : intl.formatMessage({
                id: "app.mobile.first_visit",
              })}
        </IonBadge>
      </IonLabel>
    </IonItem>
  );
};

export default VisitItem;
